export enum BibleNotifications {
  BIBLE_CREATED = 'BIBLE_CREATED',
  BIBLE_PROGRESS = 'BIBLE_PROGRESS',
  BIBLE_UPDATED = 'BIBLE_UPDATED',
}
